import React from 'react'

export const useToggle = (defaultValue = false): [boolean, () => void] => {
  const [value, setValue] = React.useState(defaultValue)

  const onToggle = React.useCallback(() => {
    setValue((v) => !v)
  }, [])

  return [value, onToggle]
}
